import { Party } from "src/app/party/party.model";
import {ChartOfAccounts} from "../../../chart-of-accounts/chart-of-accounts.model";
import {JournalEntryLineDimension} from "./journal-entry-detail-dimension.model";

export class JournalItem {

    itemId?: number;
    entryId?: number;
    account: ChartOfAccounts;
    name: string;
    debit: number;
    credit: number;
    logisticsProjectId?: number;
    party: Party;
    dimensions: JournalEntryLineDimension[];

}
